import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import * as R from 'ramda'

import { getZendeskAuthenticationSetting } from 'actions'
import ZendeskIntegrationSettingsPresentation from 'components/Admin/Surveys/ZendeskIntegrationSettings'

class IntegrationSettings extends React.Component {
  static propTypes = {
    match: PropTypes.object,
    getZendeskAuthenticationSetting: PropTypes.func,
    isUpdateTicketTagsAndCommentActive: PropTypes.bool,
    isZendeskSatisfactionRatingBackwardSyncActive: PropTypes.bool,
  }

  async componentDidMount() {
    await this.props.getZendeskAuthenticationSetting()
  }

  render() {
    return (
      <ZendeskIntegrationSettingsPresentation
        match={this.props.match}
        isUpdateTicketTagsAndCommentActive={this.props.isUpdateTicketTagsAndCommentActive}
        isZendeskSatisfactionRatingBackwardSyncActive={
          this.props.isZendeskSatisfactionRatingBackwardSyncActive
        }
        history={this.props.history}
      />
    )
  }
}

const mapState = ({ data: { surveys } }, { match }) => ({
  isUpdateTicketTagsAndCommentActive: R.path(
    ['settings', 'updateTicketTagsAndComment', 'isActive'],
    surveys.entity[match.params.surveyId]
  ),
  isZendeskSatisfactionRatingBackwardSyncActive: R.path(
    ['settings', 'addSatisfaction', 'isActive'],
    surveys.entity[match.params.surveyId]
  ),
})

const mapDispatch = (dispatch) => ({
  getZendeskAuthenticationSetting: () => dispatch(getZendeskAuthenticationSetting()),
})

export default withRouter(connect(mapState, mapDispatch)(IntegrationSettings))



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/containers/Admin/Surveys/ZendeskIntegrationSettings/index.js